<template>
  <div>
    <header class="vff-header">
      <div class="tadam-logo-container">
        <a class="tadam-website-redirect" href="https://tadamescape.fr">
          <svg class="tadam-logo" enable-background="new 0 0 1920 1080" version="1.1" viewBox="0 0 1920 1080" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
            <path class="st0" d="m152 596.4c-6-28.1-33.6-46.1-61.7-40.1s-46.1 33.6-40.1 61.7 33.6 46.1 61.7 40.1c28.1-5.9 46.1-33.5 40.1-61.7zm-47 29.4c-10.2 2.2-20.3-4.4-22.5-14.6s4.4-20.3 14.6-22.5 20.3 4.4 22.5 14.6-4.4 20.3-14.6 22.5z"/><path class="st0" d="m98.9 560.7-14.7 3.1c-0.9 0.2-1.9-0.4-2.1-1.3l-2.8-13.3c-0.2-0.9 0.4-1.9 1.3-2.1l14.7-3.1c0.9-0.2 1.9 0.4 2.1 1.3l2.8 13.3c0.2 1-0.4 1.9-1.3 2.1z"/><path class="st0" d="m75.9 568-11.2 10c-0.7 0.6-1.8 0.6-2.4-0.1l-9.1-10.1c-0.6-0.7-0.6-1.8 0.1-2.4l11.2-10c0.7-0.6 1.8-0.6 2.4 0.1l9.1 10.1c0.7 0.7 0.6 1.8-0.1 2.4z"/><path class="st0" d="m59.7 585.9-4.7 14.2c-0.3 0.9-1.3 1.4-2.2 1.1l-12.9-4.2c-0.9-0.3-1.4-1.3-1.1-2.2l4.6-14.3c0.3-0.9 1.3-1.4 2.2-1.1l12.9 4.2c1 0.4 1.5 1.4 1.2 2.3z"/><path class="st0" d="m54.5 609.4 3.1 14.7c0.2 0.9-0.4 1.9-1.3 2.1l-13.3 2.8c-0.9 0.2-1.9-0.4-2.1-1.3l-3.1-14.7c-0.2-0.9 0.4-1.9 1.3-2.1l13.3-2.8c1-0.2 1.9 0.4 2.1 1.3z"/><path class="st0" d="m61.9 632.4 10 11.2c0.6 0.7 0.6 1.8-0.1 2.4l-10.1 9.1c-0.7 0.6-1.8 0.6-2.4-0.1l-10-11.2c-0.6-0.7-0.6-1.8 0.1-2.4l10.1-9.1c0.6-0.7 1.7-0.6 2.4 0.1z"/><path class="st0" d="m79.7 648.6 14.3 4.6c0.9 0.3 1.4 1.3 1.1 2.2l-4.2 12.9c-0.3 0.9-1.3 1.4-2.2 1.1l-14.3-4.6c-0.9-0.3-1.4-1.3-1.1-2.2l4.2-12.9c0.3-0.9 1.3-1.4 2.2-1.1z"/><path class="st0" d="m103.3 653.8 14.7-3.1c0.9-0.2 1.9 0.4 2.1 1.3l2.8 13.3c0.2 0.9-0.4 1.9-1.3 2.1l-14.7 3.1c-0.9 0.2-1.9-0.4-2.1-1.3l-2.8-13.3c-0.3-1 0.3-1.9 1.3-2.1z"/><path class="st0" d="m126.2 646.4 11.2-10c0.7-0.6 1.8-0.6 2.4 0.1l9.1 10.1c0.6 0.7 0.6 1.8-0.1 2.4l-11.2 10c-0.7 0.6-1.8 0.6-2.4-0.1l-9.1-10.1c-0.6-0.6-0.6-1.7 0.1-2.4z"/><path class="st0" d="m142.5 628.6 4.6-14.3c0.3-0.9 1.3-1.4 2.2-1.1l12.9 4.2c0.9 0.3 1.4 1.3 1.1 2.2l-4.6 14.3c-0.3 0.9-1.3 1.4-2.2 1.1l-12.9-4.2c-0.9-0.3-1.4-1.3-1.1-2.2z"/><path class="st0" d="m147.6 605-3.1-14.7c-0.2-0.9 0.4-1.9 1.3-2.1l13.3-2.8c0.9-0.2 1.9 0.4 2.1 1.3l3.1 14.7c0.2 0.9-0.4 1.9-1.3 2.1l-13.3 2.8c-1 0.3-1.9-0.3-2.1-1.3z"/><path class="st0" d="m140.3 582.1-10-11.2c-0.6-0.7-0.6-1.8 0.1-2.4l10.1-9.1c0.7-0.6 1.8-0.6 2.4 0.1l10 11.2c0.6 0.7 0.6 1.8-0.1 2.4l-10.1 9.1c-0.7 0.6-1.8 0.6-2.4-0.1z"/><path class="st0" d="m122.4 565.8-14.3-4.6c-0.9-0.3-1.4-1.3-1.1-2.2l4.2-12.9c0.3-0.9 1.3-1.4 2.2-1.1l14.3 4.6c0.9 0.3 1.4 1.3 1.1 2.2l-4.2 12.9c-0.3 0.9-1.3 1.4-2.2 1.1z"/><path class="st0" d="m252.6 722.1c-7.4-34.7-41.5-56.9-76.3-49.6s-56.9 41.5-49.6 76.3c7.4 34.7 41.5 56.9 76.3 49.6s56.9-41.5 49.6-76.3zm-55 51c-20.8 4.4-41.2-8.9-45.7-29.7-4.4-20.8 8.9-41.2 29.7-45.7 20.8-4.4 41.2 8.9 45.7 29.7 4.4 20.9-8.9 41.3-29.7 45.7z"/><path class="st0" d="m200 677.3h-20.7c-0.8 0-1.4-0.6-1.4-1.4v-17.5c0-0.8 0.6-1.4 1.4-1.4h20.7c0.8 0 1.4 0.6 1.4 1.4v17.5c0 0.8-0.6 1.4-1.4 1.4z"/><path class="st0" d="m169.5 679.9-17.9 10.4c-0.7 0.4-1.5 0.2-1.9-0.5l-8.8-15.2c-0.4-0.7-0.2-1.5 0.5-1.9l17.9-10.4c0.7-0.4 1.5-0.2 1.9 0.5l8.8 15.2c0.4 0.7 0.2 1.5-0.5 1.9z"/><path class="st0" d="m144.5 697.4-10.4 17.9c-0.4 0.7-1.2 0.9-1.9 0.5l-15.2-8.8c-0.7-0.4-0.9-1.2-0.5-1.9l10.4-17.9c0.4-0.7 1.2-0.9 1.9-0.5l15.2 8.8c0.6 0.4 0.8 1.3 0.5 1.9z"/><path class="st0" d="m131.5 725.1v20.7c0 0.8-0.6 1.4-1.4 1.4h-17.5c-0.8 0-1.4-0.6-1.4-1.4v-20.7c0-0.8 0.6-1.4 1.4-1.4h17.5c0.8 0 1.4 0.6 1.4 1.4z"/><path class="st0" d="m134.1 755.6 10.4 17.9c0.4 0.7 0.2 1.5-0.5 1.9l-15.2 8.8c-0.7 0.4-1.5 0.2-1.9-0.5l-10.4-17.9c-0.4-0.7-0.2-1.5 0.5-1.9l15.2-8.8c0.7-0.4 1.5-0.2 1.9 0.5z"/><path class="st0" d="m151.6 780.6 17.9 10.4c0.7 0.4 0.9 1.2 0.5 1.9l-8.8 15.2c-0.4 0.7-1.2 0.9-1.9 0.5l-17.9-10.4c-0.7-0.4-0.9-1.2-0.5-1.9l8.8-15.2c0.4-0.6 1.2-0.9 1.9-0.5z"/><path class="st0" d="m179.3 793.6h20.7c0.8 0 1.4 0.6 1.4 1.4v17.5c0 0.8-0.6 1.4-1.4 1.4h-20.7c-0.8 0-1.4-0.6-1.4-1.4v-17.5c0-0.8 0.6-1.4 1.4-1.4z"/><path class="st0" d="m209.7 791 17.9-10.4c0.7-0.4 1.5-0.2 1.9 0.5l8.8 15.2c0.4 0.7 0.2 1.5-0.5 1.9l-17.9 10.4c-0.7 0.4-1.5 0.2-1.9-0.5l-8.8-15.2c-0.4-0.7-0.1-1.5 0.5-1.9z"/><path class="st0" d="m234.8 773.5 10.4-17.9c0.4-0.7 1.2-0.9 1.9-0.5l15.2 8.8c0.7 0.4 0.9 1.2 0.5 1.9l-10.4 17.9c-0.4 0.7-1.2 0.9-1.9 0.5l-15.2-8.8c-0.6-0.4-0.9-1.2-0.5-1.9z"/><path class="st0" d="m247.8 745.8v-20.7c0-0.8 0.6-1.4 1.4-1.4h17.5c0.8 0 1.4 0.6 1.4 1.4v20.7c0 0.8-0.6 1.4-1.4 1.4h-17.5c-0.8 0-1.4-0.6-1.4-1.4z"/><path class="st0" d="m245.2 715.4-10.4-17.9c-0.4-0.7-0.2-1.5 0.5-1.9l15.2-8.8c0.7-0.4 1.5-0.2 1.9 0.5l10.4 17.9c0.4 0.7 0.2 1.5-0.5 1.9l-15.2 8.8c-0.7 0.4-1.6 0.1-1.9-0.5z"/><path class="st0" d="m227.7 690.3-17.9-10.4c-0.7-0.4-0.9-1.2-0.5-1.9l8.8-15.2c0.4-0.7 1.2-0.9 1.9-0.5l17.9 10.4c0.7 0.4 0.9 1.2 0.5 1.9l-8.8 15.2c-0.4 0.6-1.3 0.9-1.9 0.5z"/><path class="st0" d="m520.7 434.8c-19.6-92.4-110.4-151.4-202.8-131.9s-151.4 110.4-131.8 202.8 110.4 151.4 202.8 131.9c92.4-19.6 151.4-110.4 131.8-202.8zm-146.1 135.6c-55.3 11.7-109.7-23.6-121.4-78.9s23.6-109.7 78.9-121.4 109.7 23.6 121.4 78.9c11.8 55.3-23.5 109.7-78.9 121.4z"/><path class="st0" d="m383.3 315.6h-59.7c-0.8 0-1.4-0.6-1.4-1.4v-51.2c0-0.8 0.6-1.4 1.4-1.4h59.7c0.8 0 1.4 0.6 1.4 1.4v51.2c0 0.8-0.7 1.4-1.4 1.4z"/><path class="st0" d="m301.9 321.4-51.7 29.9c-0.7 0.4-1.5 0.2-1.9-0.5l-25.6-44.4c-0.4-0.7-0.2-1.5 0.5-1.9l51.7-29.9c0.7-0.4 1.5-0.2 1.9 0.5l25.6 44.4c0.4 0.7 0.2 1.5-0.5 1.9z"/><path class="st0" d="m234.4 367.1-29.9 51.7c-0.4 0.7-1.2 0.9-1.9 0.5l-44.4-25.6c-0.7-0.4-0.9-1.2-0.5-1.9l29.9-51.7c0.4-0.7 1.2-0.9 1.9-0.5l44.4 25.6c0.7 0.3 0.9 1.2 0.5 1.9z"/><path class="st0" d="m198.8 440.4v59.7c0 0.8-0.6 1.4-1.4 1.4h-51.2c-0.8 0-1.4-0.6-1.4-1.4v-59.7c0-0.8 0.6-1.4 1.4-1.4h51.2c0.7 0 1.4 0.6 1.4 1.4z"/><path class="st0" d="m204.5 521.7 29.9 51.7c0.4 0.7 0.2 1.5-0.5 1.9l-44.4 25.7c-0.7 0.4-1.5 0.2-1.9-0.5l-29.9-51.7c-0.4-0.7-0.2-1.5 0.5-1.9l44.4-25.6c0.7-0.5 1.6-0.3 1.9 0.4z"/><path class="st0" d="m250.2 589.2 51.7 29.9c0.7 0.4 0.9 1.2 0.5 1.9l-25.6 44.4c-0.4 0.7-1.2 0.9-1.9 0.5l-51.7-29.9c-0.7-0.4-0.9-1.2-0.5-1.9l25.6-44.4c0.4-0.6 1.2-0.9 1.9-0.5z"/><path class="st0" d="m323.5 624.9h59.7c0.8 0 1.4 0.6 1.4 1.4v51.2c0 0.8-0.6 1.4-1.4 1.4h-59.7c-0.8 0-1.4-0.6-1.4-1.4v-51.2c0-0.8 0.6-1.4 1.4-1.4z"/><path class="st0" d="m404.8 619.1 51.7-29.9c0.7-0.4 1.5-0.2 1.9 0.5l25.6 44.4c0.4 0.7 0.2 1.5-0.5 1.9l-51.7 29.9c-0.7 0.4-1.5 0.2-1.9-0.5l-25.6-44.4c-0.4-0.7-0.1-1.5 0.5-1.9z"/><path class="st0" d="m472.4 573.4 29.9-51.7c0.4-0.7 1.2-0.9 1.9-0.5l44.4 25.6c0.7 0.4 0.9 1.2 0.5 1.9l-29.9 51.7c-0.4 0.7-1.2 0.9-1.9 0.5l-44.4-25.6c-0.7-0.3-0.9-1.2-0.5-1.9z"/><path class="st0" d="m508 500.1v-59.7c0-0.8 0.6-1.4 1.4-1.4h51.2c0.8 0 1.4 0.6 1.4 1.4v59.7c0 0.8-0.6 1.4-1.4 1.4h-51.2c-0.8 0-1.4-0.6-1.4-1.4z"/><path class="st0" d="m502.2 418.8-29.9-51.7c-0.4-0.7-0.2-1.5 0.5-1.9l44.4-25.6c0.7-0.4 1.5-0.2 1.9 0.5l29.9 51.7c0.4 0.7 0.2 1.5-0.5 1.9l-44.4 25.6c-0.6 0.4-1.5 0.2-1.9-0.5z"/><path class="st0" d="m456.6 351.3-51.7-29.9c-0.7-0.4-0.9-1.2-0.5-1.9l25.6-44.4c0.4-0.7 1.2-0.9 1.9-0.5l51.7 29.9c0.7 0.4 0.9 1.2 0.5 1.9l-25.6 44.4c-0.4 0.6-1.3 0.9-1.9 0.5z"/><rect class="st0" transform="matrix(.9944 -.1057 .1057 .9944 -40.925 75.699)" x="584.3" y="392.6" width="219" height="62.7"/><rect class="st0" transform="matrix(.1057 .9944 -.9944 .1057 1205.6 -186.92)" x="581.4" y="545.5" width="250.6" height="62.7"/><path class="st0" d="m894.7 364.8-101.4 325.6 64.5-6.4 15.3-49.7 103.9-10.4 24.6 41.4 66-8.1-172.9-292.4zm35.4 209.3c0.4 4.8-3.1 9-7.9 9.4l-4 0.3c-4.8 0.4-9-3.1-9.4-7.9l-2.2-26.1c-8.6-3.2-14.7-11.4-14.7-21.1 0-12.5 10.1-22.6 22.6-22.6s22.6 10.1 22.6 22.6c0 7.5-3.6 14.1-9.2 18.2l2.2 27.2z"/><path class="st0" d="m1162.3 343.8c-32 0-57.7 1-105.8 9.6l34.7 300.4c41.7-2.2 41.7-2.2 71.2-6 77.1-10.1 140.8-68 140.8-151.9-0.1-84.1-63.1-152.1-140.9-152.1zm74.6 173c-10.5 71.6-92.9 71.3-92.9 71.3l-20.7-181.3c75.9-16.3 124.1 38.4 113.6 110z"/><path class="st0" d="m1404.6 307.1-101.5 325.6 64.5-6.4 15.3-49.7 103.9-10.3 24.6 41.4 66-8.1-172.8-292.5zm35.3 209.2c0.4 4.8-3.1 9-7.9 9.4l-4 0.3c-4.8 0.4-9-3.1-9.4-7.9l-2.2-26.1c-8.6-3.2-14.7-11.4-14.7-21.1 0-12.5 10.1-22.6 22.6-22.6s22.6 10.1 22.6 22.6c0 7.5-3.6 14.1-9.2 18.2l2.2 27.2z"/><circle class="st0" cx="353.4" cy="470.3" r="68.7"/><polygon class="st0" points="695.1 733.9 695.1 844.4 761.5 844.4 761.5 823.1 715.8 823.1 715.8 800.3 751.6 800.3 751.6 777.9 715.8 777.9 715.8 755.1 761.5 755.1 761.5 733.9"/><polygon class="st0" points="1137.9 733.9 1137.9 844.4 1204.3 844.4 1204.3 823.1 1158.6 823.1 1158.6 800.3 1194.4 800.3 1194.4 777.9 1158.6 777.9 1158.6 755.1 1204.3 755.1 1204.3 733.9"/><path class="st0" d="m925.1 811.7s-21.7 20-43.4 4.3-12.7-47.7 0-54.7 27.4-8.3 43.4 4.7l15-15.7s-23.7-28.7-63.8-12.4c-40.1 16.4-42.4 88.1 0 103.1s63.8-11 63.8-11l-15-18.3z"/><path class="st0" d="m793.3 811.6h-23s2 37.6 35.8 34.1c33.7-3.5 37.8-37.6 28.4-49.4-14.2-18.1-25.2-12-39.4-24.4-5.7-4.9-1-16.6 7.6-17 6.2-0.3 12.4 3.7 12.6 11.6h22.5s3.1-29-32.2-33.6-39.2 41.5-26.7 53.4c16.6 15.8 40.4 14.8 36.5 28.8-4 13.9-21.7 10.8-22.1-3.5z"/><path class="st0" d="m993 730.5-49.9 112.9h24.1l7.1-15.9h38.3l6.6 15.9h24.5l-50.7-112.9zm-11.3 76.4 9.9-22.8 9.9 22.8h-19.8z"/><path class="st0" d="m1050.8 733.9v109.5h22.5v-33.3s55.5 3 55.5-36.7c0.1-44.1-52.3-41.7-78-39.5zm56.8 39.7c-1.5 18.5-33.9 15.5-33.9 15.5v-34c11.9-0.1 35.4 0 33.9 18.5z"/><polygon class="st0" points="1601.1 596.4 1566.2 288.4 1736.1 473.3 1859.5 255.3 1895.9 563.6 1832.8 570.6 1821.1 446.6 1748.4 574.8 1649 469.9 1662.9 590.9"/><path class="st0" d="m356.6 751.6c-11.4-19.8-36.8-26.6-56.6-15.2s-26.6 36.8-15.2 56.6 36.8 26.6 56.6 15.2c19.9-11.4 26.7-36.7 15.2-56.6zm-25.6 38.5c-9.8 5.7-22.3 2.3-28-7.5s-2.3-22.3 7.5-28 22.3-2.3 28 7.5c5.6 9.8 2.3 22.4-7.5 28z"/><path class="st0" d="m320.8 733.5-23 7.5c-0.7 0.2-1.5-0.2-1.8-0.9l-5.4-16.6c-0.2-0.7 0.2-1.5 0.9-1.8l23-7.5c0.7-0.2 1.5 0.2 1.8 0.9l5.4 16.6c0.3 0.8-0.1 1.6-0.9 1.8z"/><path class="st0" d="m293.3 744.8-11 21.6c-0.4 0.7-1.2 1-1.9 0.6l-15.6-7.9c-0.7-0.4-1-1.2-0.6-1.9l11-21.6c0.4-0.7 1.2-1 1.9-0.6l15.6 7.9c0.7 0.4 1 1.2 0.6 1.9z"/><path class="st0" d="m281.9 772.3 7.5 23c0.2 0.7-0.2 1.5-0.9 1.8l-16.6 5.4c-0.7 0.2-1.5-0.2-1.8-0.9l-7.5-23c-0.2-0.7 0.2-1.5 0.9-1.8l16.6-5.4c0.8-0.3 1.6 0.1 1.8 0.9z"/><path class="st0" d="m293.2 799.8 21.6 11c0.7 0.4 1 1.2 0.6 1.9l-7.9 15.6c-0.4 0.7-1.2 1-1.9 0.6l-21.6-11c-0.7-0.4-1-1.2-0.6-1.9l7.9-15.6c0.4-0.7 1.2-1 1.9-0.6z"/><path class="st0" d="m320.6 811.2 23-7.5c0.7-0.2 1.5 0.2 1.8 0.9l5.4 16.6c0.2 0.7-0.2 1.5-0.9 1.8l-23 7.5c-0.7 0.2-1.5-0.2-1.8-0.9l-5.4-16.6c-0.2-0.8 0.2-1.6 0.9-1.8z"/><path class="st0" d="m348.1 799.9 11-21.6c0.4-0.7 1.2-1 1.9-0.6l15.6 7.9c0.7 0.4 1 1.2 0.6 1.9l-11 21.6c-0.4 0.7-1.2 1-1.9 0.6l-15.6-7.9c-0.6-0.4-0.9-1.2-0.6-1.9z"/><path class="st0" d="m359.6 772.5-7.5-23c-0.2-0.7 0.2-1.5 0.9-1.8l16.6-5.4c0.7-0.2 1.5 0.2 1.8 0.9l7.5 23c0.2 0.7-0.2 1.5-0.9 1.8l-16.6 5.4c-0.8 0.2-1.6-0.2-1.8-0.9z"/><path class="st0" d="m348.3 745-21.6-11c-0.7-0.4-1-1.2-0.6-1.9l7.9-15.6c0.4-0.7 1.2-1 1.9-0.6l21.6 11c0.7 0.4 1 1.2 0.6 1.9l-7.9 15.6c-0.4 0.6-1.2 0.9-1.9 0.6z"/>
          </svg>
        </a>
      </div>
    </header>

    <flow-form
      ref="flowform"
      v-on:complete="onComplete"
      v-on:submit="onSubmit"
      v-bind:questions="questions"
      v-bind:language="language"
      v-bind:standalone="true"
    >
    <!-- Custom content for the Complete/Submit screen slots in the FlowForm component -->
      <!-- We've overriden the default "complete" slot content -->
     <template v-slot:complete>
        <div class="f-section-wrap">
          <p>
            <span class="fh2"></span>
            <span class="f-section-text">
              Appuyer sur le bouton pour découvrir votre niveau approximatif.<br>
              Vous pouvez dès à présent réserver votre partie !! 🙏
            </span>
          </p>
          <p class="f-description"><small>Aucune information n'est enregistrée ni stockée suite à ce questionnaire.</small></p>
        </div>   
      </template>

      <!-- We've overriden the default "completeButton" slot content -->
      <template v-slot:completeButton>
        <div class="f-submit" v-if="!submitted">
          <button 
            class="o-btn-action"
            ref="button"
            type="submit"
            href="#"
            v-on:click.prevent="onSendData()"
            aria-label="Appuyez pour décrouvrir votre niveau"
          >
            <span>{{ language.submitText }}</span>
          </button>
          <a class="f-enter-desc"
            href="#"
            v-on:click.prevent="onSendData()"
            v-html="language.formatString(language.pressEnter)">
          </a>
        </div>
        <div v-if="submitted">
          <h1 class="text-success">{{ this.level }}</h1>
        </div>
      </template>
    </flow-form>
  </div>
</template>

<script>
  import FlowForm from './FlowForm.vue'
  import QuestionModel, { QuestionType, ChoiceOption } from '../models/QuestionModel'
  import LanguageModel from '../models/LanguageModel'

  export default {
    name: 'Questionnaire',
    components: {
      FlowForm
    },

    data() {
      return {
        submitted: false,
        completed: false,
        level: 'Mode famille / débutant',
        language: new LanguageModel(),
        // Questions list 
        questions: [
          new QuestionModel({
            id: 'nbPerson',
            tagline: 'Hey ! Voici notre questionnaire qui t\'aidera à choisir le niveau le plus adéquat pour ta partie 😊',
            title: 'Combien de personnes participent ?',
            type: QuestionType.Number,
            required: true,
            placeholder: 'ex: 4',
            min: '2',
            max: '6'
          }),
          new QuestionModel({
            id: 'nbChild',
            tagline: "On continue ! 👀",
            title: 'Combien d\'enfants composent votre équipe ? (jusqu\'à 12 ans)',
            type: QuestionType.Number,
            required: true,
            placeholder: 'ex: 2',
            min: '0',
            max: '6'
          }),
          new QuestionModel({ 
            id: 'nbParty',
            tagline: 'C\'est presque fini !',
            title: 'Combien votre équipe a-t-elle fait de parties en moyenne ?',
            helpTextShow: false,
            type: QuestionType.MultipleChoice,
            multiple: false,
            required: true,
            options: [
              new ChoiceOption({
                label: '0-3 partie(s)'
              }),
              new ChoiceOption({
                label: '4-10 parties'
               }),
              new ChoiceOption({
                label: '10+ parties'
              })
            ]
          }),
          new QuestionModel({
            id: 'nbParty',
            tagline: 'C\'est la dernière !',
            title: 'Vous cherchez à jouer: ',
            type: QuestionType.MultiplePictureChoice,
            multiple: false,
            required: true,
            options: [
              new ChoiceOption({
                imageSrc: require('../assets/svg/feather.svg'),
                imageAlt: 'Facile',
                label: 'Pour profiter des énigmes et des décors ?'
                
              }),
              new ChoiceOption({
                imageSrc: require('../assets/svg/skull.svg'),
                imageAlt: 'Difficile',
                label: 'Pour vous mettre en difficulté ?'
              })
            ]
          }),          
        ]
      }
    },

    mounted() {
      document.addEventListener('keyup', this.onKeyListener)
    },

    beforeUnmount() {
      document.removeEventListener('keyup', this.onKeyListener)
    },

    methods: {
      onKeyListener($event) {
        // We've overriden the default "complete" slot so
        // we need to implement the "keyup" listener manually.

        if ($event.key === 'Enter' && this.completed && !this.submitted) {
          this.onSendData()
        }
      },

      onComplete(completed) {
        // This method is called whenever the "completed" status is changed.
        this.completed = completed
      },

      onSubmit() {
        // This method will only be called if you don't override the
        // completeButton slot.
        this.onSendData()
      },
      
      onSendData() {
        // Set `submitted` to true so the form knows not to allow back/forward
        // navigation anymore.
        this.$refs.flowform.submitted = true
        this.submitted = true
        this.getLevel()
      },

      getData() {
        const data = {
          questions: [],
          answers: []
        }

        this.questions.forEach(question => {
          if (question.title) {
            let answer = question.answer
            if (Array.isArray(answer)) {
              answer = answer.join(', ')
            }

            data.questions.push(question.title)
            data.answers.push(answer)
          }
        })

        return data
      },

      getLevel() {
        // get Values from form
        let data = this.getData()

        // transform data
        let answers = {
          'nbPlayer': data.answers[0],
          'nbChild': data.answers[1],
          'nbParty': data.answers[2],
          'difficulty': data.answers[3]
        }

        // Enum difficulty
        let difficulty = {
          EASY: 'Pour profiter des énigmes et des décors ?',
          HARD: 'Pour vous mettre en difficulté ?'
        }

        // Enum nbParty
        let nbParty = {
          LOW: '0-3 partie(s)',
          MEDIUM: '4-10 parties',
          HIGH: '10+ parties'
        }

        // Enum level
        let level = {
          CHILD: 'Mode enfant',
          FAMILY: 'Mode famille / débutant',
          ADULT: 'Mode adulte',
          EXPERT: 'Mode expert'
        }

        if(answers.nbChild == '0'){
          console.log('enfant = 0')
          if(answers.nbParty == nbParty.LOW || 
          (answers.difficulty == difficulty.EASY && answers.nbParty != nbParty.HIGH)){
            this.level = level.FAMILY
            return this.level
          }

          if(answers.nbParty == nbParty.MEDIUM){
            this.level = level.ADULT
            return this.level
          }

          if(answers.nbParty == nbParty.HIGH){
            if(answers.difficulty == difficulty.HARD){
              this.level = level.EXPERT
              return this.level
            }

            if(answers.difficulty == difficulty.EASY){
              this.level = level.ADULT
              return this.level
            }
          }
        }

        if(answers.nbChild > answers.nbPlayer - answers.nbChild){
          this.level = level.CHILD
          return this.level
        }

        // Peut être changé les règle s'ils ont déjà bcp joué ou non
        if(answers.nbChild == answers.nbPlayer - answers.nbChild){
          console.log('enfant = parent')
          if(answers.difficulty == difficulty.EASY){
            this.level = level.FAMILY
            return this.level
          }

          if(answers.difficulty == difficulty.HARD){
            this.level = level.ADULT
            return this.level
          }
        }

        if(answers.nbChild < answers.nbPlayer - answers.nbChild){
          if(answers.difficulty == difficulty.EASY){
            this.level = level.FAMILY
            return this.level
          }

          if(answers.difficulty == difficulty.HARD){
            this.level = level.ADULT
            return this.level
          }
        }    

        return null
      }
    }
  }
</script>

<style lang="css">
  @import '../../src/assets/css/themes/theme-minimal.css';
</style>